import routerOptions0 from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}